import * as React from 'react';
export const SVGComponent = (props) => (
  <svg
    height={16}
    viewBox='0 0 11.173 16.836'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.213,49.2v2.2a4.386,4.386,0,0,1,.731,6.356,1.234,1.234,0,0,1-1.89-1.587A1.948,1.948,0,0,0,7.5,54.928c0-2.457-3.836-2.576-3.836,0a1.948,1.948,0,0,0,.447,1.241,1.234,1.234,0,0,1-1.89,1.587A4.386,4.386,0,0,1,2.953,51.4V49.19a5.873,5.873,0,0,1-.863-.548A5.744,5.744,0,0,1,.036,45.574a1.219,1.219,0,0,1,2.356-.63,3.295,3.295,0,0,0,3.194,2.444,3.292,3.292,0,0,0,2.009-.68,3.326,3.326,0,0,0,1.178-1.764,1.219,1.219,0,0,1,2.356.63,5.709,5.709,0,0,1-2.054,3.068,5.873,5.873,0,0,1-.863.548ZM5.586,41.36a2.46,2.46,0,1,1-2.457,2.463A2.457,2.457,0,0,1,5.586,41.36Z'
      data-name='Path 4321'
      fill='#007e75'
      fillRule='evenodd'
      id='Path_4321'
      transform='translate(0.004 -41.36)'
    />
  </svg>
);
